import PropTypes from 'prop-types';

import Calendar from './calendar';
import ArrowWrapper from './arrow-wrapper';

const MobileCalendarLayout = ({arrowParams, dateSelectParams}) => (
  <div className="appointment-container">
    <ArrowWrapper {...arrowParams}>
      <div className="calendar-bar">
        <h3 className="month">{dateSelectParams.selectedDay.format('MMMM YYYY')}</h3>
      </div>
    </ArrowWrapper>

    <Calendar {...dateSelectParams} />
  </div>
);

MobileCalendarLayout.propTypes = {
  arrowParams: PropTypes.object.isRequired,
  dateSelectParams: PropTypes.object.isRequired,
};

export default MobileCalendarLayout;
